var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLighting = function SvgLighting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lighting_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6500",
    d: "M8.75.75A.75.75 0 0 0 8 0a.75.75 0 0 0-.75.75v4.284a8 8 0 0 0-7.187 6.97C-.007 12.55.447 13 1 13h14c.553 0 1.006-.45.938-.997A8.006 8.006 0 0 0 8.75 5.034zm5.575 10.75H1.675a6.502 6.502 0 0 1 12.65 0M8 16c1.103 0 2-.897 2-2H6c0 1.103.897 2 2 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lighting_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLighting;